import { OrderedMap } from 'immutable';
import * as ActionTypes from '../actions/ActionTypes';
import ListRecord from '../records/ListRecord';
import ListsRecord from '../records/ListsRecord';
const INITIAL_STATE = new ListsRecord();
export function listsDetail(state = INITIAL_STATE, action) {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case ActionTypes.FETCH_LISTS_DETAIL_PENDING:
      return state.merge({
        isRequesting: true,
        error: undefined
      });
    case ActionTypes.FETCH_LISTS_DETAIL_SUCCESS:
      return state.merge({
        lists: OrderedMap(payload.lists.map(list => [list.listId, new ListRecord(list)])),
        isRequesting: false,
        lastLoaded: new Date().valueOf()
      });
    case ActionTypes.FETCH_LISTS_DETAIL_ERROR:
      return state.merge({
        isRequesting: false,
        error: payload
      });
    case ActionTypes.ADD_TO_LISTS_DETAIL:
      return (payload || []).reduce((acc, list) => acc.updateIn(['lists', list.listId], () => new ListRecord(list)), state);
    case ActionTypes.SHOW_ARTICLE_VISIBILITY_SUCCESS_NOTIFICATION:
    case ActionTypes.SHOW_ARTICLES_VISIBILITY_BULK_SUCCESS_NOTIFICATION:
      // Resets after the notification is shown
      return INITIAL_STATE;
    default:
      return state;
  }
}
export default listsDetail;